import { Kampos, effects, noise, utilities } from 'kampos';
export default async function create(target, options) {
  const {
    octaves = 4,
    radius = 0.25,
    spread = 1,
    grayscale = false,
    invert = true,
    gain = 10,
    useMouse = false,
    useDisplacement = false,
    isFractal = true
  } = options.namedEffect;
  let {
    speed = 2,
    frequency = 1
  } = options.namedEffect;
  const circle = utilities.circle();
  const mouse = utilities.mouse({
    initial: {
      x: 0.5,
      y: 0.5
    }
  });
  const width = target.width || 1;
  const height = target.height || 1;
  const resolution = utilities.resolution({
    width,
    height
  });
  const frequency_ = {
    x: frequency / width,
    y: frequency / height
  };
  const turbulence = effects.turbulence({
    noise: noise.simplex,
    frequency: frequency_,
    octaves,
    isFractal,
    output: ''
  });
  const render = {
    fragment: {
      uniform: {
        u_radius: 'float',
        u_spread: 'float',
        u_gain: 'float',
        u_grayscale: 'bool',
        u_invert: 'bool',
        u_useMouse: 'bool',
        u_useDisplacement: 'bool'
      },
      source: `
    float ar_ = u_resolution.x / u_resolution.y;
    vec2 st_ = gl_FragCoord.xy / u_resolution;
    float c_ = 1.0;

    if (u_useMouse || u_radius == 1.0) {
      c_ = circle(vec2(st_.x * ar_, st_.y), vec2(u_mouse.x * ar_, u_mouse.y), u_radius, u_spread);
    }

    float value_ = (turbulenceValue - 0.5) * c_;

    if (u_useDisplacement) {
      sourceCoord += vec2(value_);
    }`,
      main: `
    if (value_ > 0.001) {
      vec3 newColor_ = color;

      if (u_grayscale) {
        newColor_ = vec3(dot(color, lumcoeff));
      }
      if (u_invert) {
        newColor_ = vec3(1.0) - newColor_;
      }

      color = mix(color, newColor_, vec3(smoothstep(0.0, 1.0, value_ * u_gain)));
    }`
    },
    uniforms: [{
      name: 'u_radius',
      type: 'f',
      data: [radius]
    }, {
      name: 'u_spread',
      type: 'f',
      data: [spread]
    }, {
      name: 'u_grayscale',
      type: 'i',
      data: [+grayscale]
    }, {
      name: 'u_invert',
      type: 'i',
      data: [+invert]
    }, {
      name: 'u_gain',
      type: 'f',
      data: [gain]
    }, {
      name: 'u_useMouse',
      type: 'i',
      data: [+useMouse]
    }, {
      name: 'u_useDisplacement',
      type: 'i',
      data: [+useDisplacement]
    }],
    get radius() {
      return this.uniforms[0].data[0];
    },
    set radius(r) {
      this.uniforms[0].data[0] = r;
    },
    get spread() {
      return this.uniforms[1].data[0];
    },
    set spread(s) {
      this.uniforms[1].data[0] = s;
    },
    get grayscale() {
      return !!this.uniforms[2].data[0];
    },
    set grayscale(g) {
      this.uniforms[2].data[0] = +g;
    },
    get invert() {
      return !!this.uniforms[3].data[0];
    },
    set invert(i) {
      this.uniforms[3].data[0] = +i;
    },
    get gain() {
      return this.uniforms[4].data[0];
    },
    set gain(g) {
      this.uniforms[4].data[0] = g;
    },
    get useMouse() {
      return !!this.uniforms[5].data[0];
    },
    set useMouse(b) {
      this.uniforms[5].data[0] = +b;
    },
    get useDisplacement() {
      return !!this.uniforms[6].data[0];
    },
    set useDisplacement(b) {
      this.uniforms[6].data[0] = +b;
    }
  };
  const instance = new Kampos({
    effects: [circle, resolution, mouse, turbulence, render],
    target
  });
  return {
    instance,
    beforeDraw(time) {
      turbulence.time = time * speed;
    },
    play(_temp) {
      let {
        beforeDraw
      } = _temp === void 0 ? {} : _temp;
      this.instance.play(beforeDraw);
    },
    setters: {
      speed(s) {
        speed = s;
      },
      mouse(p) {
        if (p.active !== false) {
          mouse.position = p;
        }
      },
      radius(r) {
        render.radius = r;
      },
      spread(s) {
        render.spread = s;
      },
      frequency(f) {
        frequency = f;
        turbulence.frequency = {
          x: f / instance.config.target.width,
          y: f / instance.config.target.width
        };
      },
      octaves(o) {
        turbulence.octaves = o;
      },
      isFractal(f) {
        turbulence.isFractal = f;
      },
      grayscale(g) {
        render.grayscale = g;
      },
      invert(i) {
        render.invert = i;
      },
      gain(g) {
        render.gain = g;
      },
      useMouse(b) {
        render.useMouse = b;
      },
      useDisplacement(b) {
        render.useDisplacement = b;
      }
    },
    resize(w, h) {
      resolution.resolution = {
        width: w,
        height: h
      };
      turbulence.frequency = {
        x: frequency / w,
        y: frequency / h
      };
      instance.setSource({
        width: w,
        height: h
      });
    }
  };
}
//# sourceMappingURL=NoiseRecolor.js.map